import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=42e2c9e0&scoped=true"
import script from "./not-found.vue?vue&type=script&lang=js"
export * from "./not-found.vue?vue&type=script&lang=js"
import style0 from "./not-found.vue?vue&type=style&index=0&id=42e2c9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2c9e0",
  null
  
)

export default component.exports